import { worker } from "./client";

export type ClearanceSubmission = {
  report_id: string;
  status: "pending" | "running" | "completed" | "failed";
};

// Worker returns 202 + {report_id,status:"pending"} in < 1s.
// The pipeline runs asynchronously on the Lambda and writes status updates
// to DynamoDB. The frontend polls /reports/{report_id} for completion.
export async function submitClearance(
  brandName: string,
  niceClass: number,
  token: string,
): Promise<ClearanceSubmission> {
  const { data } = await worker.post<ClearanceSubmission>(
    "/clearance",
    { brand_name: brandName, nice_class: niceClass },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
}
